import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import "./../../UaeAttestation/UaeService/UaeService.css";
const FranceServiceMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          France Attestation in India is a regionalized procedure & it is
          generally procured with the intervention of Attestation services in
          India. Authentication for France is the procedure of authenticating
          the documents to expand your business or to obtain a visa in France.
          It is a prerequisite step that is to be taken if you are planning to
          travel to France.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          The document legalization is the procedure of obtaining the MEA
          sticker on the document. It is a part of the legalization that proves
          the trustworthiness of your documents & your purpose of visiting
          France. Attestation documents in India are provided by the MEA which
          is a division of the Indian government that deals with foreign
          affairs.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          You can get France Attestation service in Bangalore for certificates
          at Goodwayattestation which is approved by Ministries & embassies in
          India as well as abroad. We provide you best quality services & will
          complete the entire procedure of your document attestation faster.
        </li>
      </ul>
    </div>
  );
};

export default FranceServiceMain;
